/**
 * @generated SignedSource<<9fdebe6abd3a68ef46cd0e7a31753030>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TxnClassificationEnum = "CHARGEBACK" | "DIVIDEND" | "FINANCING_FEE" | "FRAUDULENT" | "LOAN_PROCEEDS" | "LOAN_REPAYMENT" | "PROCESSOR_FEE" | "REFUND" | "SALARY" | "TAX_PAYMENT" | "TAX_REFUND" | "%future added value";
export type TxnSortEnum = "ACCOUNT" | "AMOUNT" | "CATEGORY" | "COUNTERPARTY" | "DATE" | "DESCRIPTION" | "NATURE" | "%future added value";
export type categoryDetailPanelTxns_Query$variables = {
  categoryId?: string | null | undefined;
  from?: string | null | undefined;
  perspectiveId?: string | null | undefined;
  sort?: TxnSortEnum | null | undefined;
  sortDirection?: string | null | undefined;
  to?: string | null | undefined;
};
export type categoryDetailPanelTxns_Query$data = {
  readonly allStakeholders: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly bankAccounts: ReadonlyArray<{
    readonly id: string;
    readonly last4: string | null | undefined;
    readonly name: string;
    readonly nickname: string;
  }>;
  readonly expenseNatures: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly transactions: {
    readonly limit: number;
    readonly totalAmount: number;
    readonly totalCount: number;
    readonly txns: ReadonlyArray<{
      readonly accountNumber: string | null | undefined;
      readonly amount: number;
      readonly category: string | null | undefined;
      readonly classification: TxnClassificationEnum | null | undefined;
      readonly counterparty: {
        readonly name: string;
      } | null | undefined;
      readonly description: string;
      readonly expenseNature: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly internal: boolean;
      readonly kind: string;
      readonly md5: string;
      readonly postingDate: string;
      readonly txn: {
        readonly id: string;
      };
    }>;
  };
};
export type categoryDetailPanelTxns_Query = {
  response: categoryDetailPanelTxns_Query$data;
  variables: categoryDetailPanelTxns_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perspectiveId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortDirection"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "to"
},
v6 = {
  "kind": "Variable",
  "name": "perspectiveId",
  "variableName": "perspectiveId"
},
v7 = [
  {
    "kind": "Variable",
    "name": "categoryId",
    "variableName": "categoryId"
  },
  {
    "kind": "Variable",
    "name": "from",
    "variableName": "from"
  },
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort"
  },
  {
    "kind": "Variable",
    "name": "sortDirection",
    "variableName": "sortDirection"
  },
  {
    "kind": "Variable",
    "name": "to",
    "variableName": "to"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalAmount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "limit",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Txn",
  "kind": "LinkedField",
  "name": "txn",
  "plural": false,
  "selections": [
    (v11/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "md5",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postingDate",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountNumber",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "internal",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "classification",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v23 = [
  (v11/*: any*/),
  (v21/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseNature",
  "kind": "LinkedField",
  "name": "expenseNature",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "allStakeholders",
  "plural": true,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "BankAccount",
  "kind": "LinkedField",
  "name": "bankAccounts",
  "plural": true,
  "selections": [
    (v11/*: any*/),
    (v21/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nickname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "last4",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": [
    (v6/*: any*/)
  ],
  "concreteType": "ExpenseNature",
  "kind": "LinkedField",
  "name": "expenseNatures",
  "plural": true,
  "selections": (v23/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "categoryDetailPanelTxns_Query",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "TransactionsPage",
        "kind": "LinkedField",
        "name": "transactions",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "txns",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Stakeholder",
                "kind": "LinkedField",
                "name": "counterparty",
                "plural": false,
                "selections": [
                  (v21/*: any*/)
                ],
                "storageKey": null
              },
              (v22/*: any*/),
              (v24/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "categoryDetailPanelTxns_Query",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "TransactionsPage",
        "kind": "LinkedField",
        "name": "transactions",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "txns",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Stakeholder",
                "kind": "LinkedField",
                "name": "counterparty",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v22/*: any*/),
              (v24/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      },
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/)
    ]
  },
  "params": {
    "cacheID": "d545e0d8e09f51ef4d28dd0ed79102a1",
    "id": null,
    "metadata": {},
    "name": "categoryDetailPanelTxns_Query",
    "operationKind": "query",
    "text": "query categoryDetailPanelTxns_Query(\n  $categoryId: ID\n  $perspectiveId: ID\n  $from: String\n  $to: String\n  $sort: TxnSortEnum\n  $sortDirection: String\n) {\n  transactions(categoryId: $categoryId, perspectiveId: $perspectiveId, from: $from, to: $to, sort: $sort, sortDirection: $sortDirection) {\n    totalCount\n    totalAmount\n    limit\n    txns {\n      txn {\n        id\n      }\n      md5\n      postingDate\n      description\n      amount\n      kind\n      accountNumber\n      internal\n      classification\n      counterparty {\n        name\n        id\n      }\n      category\n      expenseNature {\n        id\n        name\n      }\n      id\n    }\n    id\n  }\n  allStakeholders {\n    id\n    name\n  }\n  bankAccounts {\n    id\n    name\n    nickname\n    last4\n  }\n  expenseNatures(perspectiveId: $perspectiveId) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "05b55c43089c4d6c6c8b6b22a823fc40";

export default node;
